import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'cs-item-divider',
    templateUrl: 'cs-item.html',
    host: { 'class': 'item-divider' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsItemDividerComponent {

}